import React, { useEffect, useRef, useState } from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import LaptopImage from '@assets/manager-getstarted-laptop.png';
import LaptopImage2x from '@assets/manager-getstarted-laptop-2x.png';
import LaptopImageShadow from '@assets/manager-getstarted-laptop-shadow.png';
import JetFontIcon, {
  JET_FONTICON_ALIASES,
} from '@src/shared/components/JetFontIcon';
import JetButton from '@src/shared/components/JetButton';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useTranslation } from 'react-i18next';
import { useScroll } from '@src/shared/hooks/use-scroll';
import { generateRotateLaptopImageAnimation, rotateLaptopImage$Animation } from '../../shared/animations';
import useInViewport from '@shared/hooks/use-in-viewport';
const ManagerGetStartedContent = (props : any) => {
  
  const classes = useStyles();
  const {isResolutionMobile} = useDeviceDetect()
  const { t } = useTranslation()
  const laptopImageRef = useRef(null)
  const laptopImage2xRef = useRef(null)
  const { scrolledPercentage,scrollTop } = useScroll()

  const laptopImageIsInViewport = useInViewport(laptopImageRef)
  const laptopImage2xIsInViewport = useInViewport(laptopImage2xRef)

  const [laptopImageAnimation, setLaptopImageAnimation] = useState<anime.AnimeInstance | null>(null)
  const [laptop2xImageAnimation, setLaptop2xImageAnimation] = useState<anime.AnimeInstance | null>(null)
  
  
  useEffect(()=> {
    rotateLaptopImage$Animation(laptopImageRef.current, scrolledPercentage, laptopImageAnimation,laptopImageIsInViewport)
    rotateLaptopImage$Animation(laptopImage2xRef.current, scrolledPercentage, laptop2xImageAnimation,laptopImage2xIsInViewport)
  },[scrollTop,laptopImageRef.current,laptopImage2xRef.current,laptopImageIsInViewport,laptopImage2xIsInViewport])

  useEffect(()=> {
    if (laptopImageRef.current && !laptopImageAnimation) {
      const animation = generateRotateLaptopImageAnimation(laptopImageRef.current)
      setLaptopImageAnimation(animation)
    }
    if (laptopImage2xRef.current && !laptop2xImageAnimation) {
      const animation = generateRotateLaptopImageAnimation(laptopImage2xRef.current)
      setLaptop2xImageAnimation(animation)
    }
  }, [laptopImageRef.current, laptopImage2xRef.current])

 

  return (
    <div className={classes.managerGetStartedContent}>
      <Typography
        variant={isResolutionMobile ? "h3" : "h1"} 
        className={`${isResolutionMobile ? "heading_l" : "heading_xxl"} managergetstartedcontent-title`}
        align="center"
      >
        <JetFontIcon
          className="title-icon"
          iconname={JET_FONTICON_ALIASES.DRIVER_MOPED}
          size={isResolutionMobile ? 24 : 33} 
        />{' '}
        {t('new_productoverview_manager.section7_title')}
      </Typography>
      <div className="managergetstarted-content-container">
        <div className="managergetstarted-content-side-section-1">
          <ul className="managergetstarted-content-side-section-1-articles">
            <li>
              {' '}
              <Typography variant="body1" className="body_regular" align="left">
                <JetFontIcon
                  className="article-icon"
                  iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE_FILLED}
                  size={24}
                />{' '}
                {t('new_productoverview_manager.section7_article1')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" className="body_regular" align="left">
                <JetFontIcon
                  className="article-icon"
                  iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE_FILLED}
                  size={24}
                />{' '}
                {t('new_productoverview_manager.section7_article2')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1" className="body_regular" align="left">
                <JetFontIcon
                  className="article-icon"
                  iconname={JET_FONTICON_ALIASES.CHECK_CIRCLE_FILLED}
                  size={24}
                />{' '}
                {t('new_productoverview_manager.section7_article3')}
              </Typography>
            </li>
          </ul>
          <JetButton onClick={props.onAction} size="large" variation="primary" className={'get_started_button'}>
          {t('new_productoverview_manager.common_get_started_button')}
          </JetButton>
        </div>
        <div className="managergetstarted-content-side-section-2" >
            <img src={LaptopImage} className='original-image' ref={laptopImageRef} />
            <img src={LaptopImage2x} className='retina-image' ref={laptopImage2xRef} />
            <img src={LaptopImageShadow} className='laptop-shadow-image' />
        </div>
      </div>
    </div>
  );
};

export default ManagerGetStartedContent;
